/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SettingsSlidersH2Icon16Light = forwardRef('SettingsSlidersH2Icon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.5 4h5.55a2.5 2.5 0 0 1 4.9 0h1.55a.5.5 0 0 1 0 1h-1.55a2.5 2.5 0 0 1-4.9 0H1.5a.5.5 0 0 1 0-1Zm8-1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.5 10a.5.5 0 0 0 0 1h1.55a2.5 2.5 0 0 0 4.9 0h5.55a.5.5 0 0 0 0-1H7.95a2.5 2.5 0 0 0-4.9 0H1.5Zm5.5.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z" })));
});
